import { Card, CardContent } from "@coval/ui/card"
import { AlertTriangle, Users } from "lucide-react"

import type { OrganizationRole } from "../types"

export function OrganizationRoleCard({ role }: { role: OrganizationRole }) {
  const admin = role === "org:admin"
  const Icon = admin ? AlertTriangle : Users

  return (
    <Card
      role={admin ? "alert" : undefined}
      className={
        admin
          ? "border-2 border-coval-warning-border bg-coval-warning-surface text-coval-warning-on-surface"
          : "bg-surface-1"
      }
    >
      <CardContent className="flex items-start gap-3 p-4 text-sm">
        <Icon size={20} className="mt-0.5 shrink-0" />
        <div className="space-y-3">
          <p
            className={
              admin ? "text-base font-bold" : "font-semibold text-coval-text"
            }
          >
            {admin ? "Warning: Admin access" : "Member — can use the platform"}
          </p>
          {admin ? (
            <>
              <p className="font-semibold">
                Admins can manage your organization and other members’ access.
              </p>
              <ul className="list-disc space-y-1 pl-4">
                <li>Use the platform.</li>
                <li>Manage organization settings.</li>
                <li>Invite and remove members, and change their roles.</li>
              </ul>
              <p className="font-bold">
                Only give this role to people you trust to manage your
                organization.
              </p>
            </>
          ) : (
            <p className="text-coval-text-muted">
              Members can use Coval. They cannot manage organization settings,
              invite or remove members, or change member roles.
            </p>
          )}
        </div>
      </CardContent>
    </Card>
  )
}
